export default __webpack_public_path__ + "static/ProValue_3-b7bd0019f6ceb63e90021b3bd0102acf.png";